module.exports = __webpack_public_path__ + "img/REG_ALIM_SANS_PORC_LISTE_NOM.86c152d3.svg";